import type { ReactNode } from 'react'
import type { ThemedPage } from '@/types'

import { Seo } from '@/components/generals/seo'
import Hero from '@/components/landing/home/hero'
import Closing from '@/components/landing/home/closing'
import Philosophy from '@/components/landing/home/philosophy'
import Signatures from '@/components/landing/home/signatures'
import SansTeaser from '@/components/landing/home/sans-teaser'

const Home: ThemedPage = (): ReactNode => {
    return (
        <>
            <Seo />

            <Hero />
            <Philosophy />
            <Signatures />
            <SansTeaser />
            <Closing />
        </>
    )
}

export default Home
